export const types = {
    SET_GET_INVITE: '[INVITE] SET GET INVITE',
    SET_GET_INVITE_BY_ID: '[INVITE] SET GET INVITE BY ID'
}